query SEARCH(
  $checkinDate: String!,
  $checkoutDate: String,
  $facility: UUID,
  $collection: UUID,
) {
  search(
    checkinDate: $checkinDate,
    checkoutDate: $checkoutDate,
    facility: $facility,
    collection: $collection
    calendarDays: 30
  ) {
    applicableSchedule
    checkinDate
    checkoutDate
    isAvailable
    price
    thumbnail
    closingTime
    openingTime
    hourlyPrice
    overnightPrice
    availability {
      availableOnDates
      unavailableOnDates
    }
    availability {
      calendar {
        availableTypes
        date
        price
        hourlyPrice
        overnightPrice
      }
    }
    lot {
      id
      name
      description
      parkerInstructions
      maxHeightSupported
      latitude
      longitude
      parkingSchedules {
        id
        name
        availableReservationTypes
        maxConsecutiveReservationDays
      }
      facility {
        name
        id
        address {
          address1
          address2
          city
          id
          state
          zipCode
        }
        status
        amenities {
          description
          name
        }
        description
        googleZoomLevel
        markedAsSoldOut
        maxBookingWindow
        paidAmenities {
          name
          price
          status
        }
        images {
          isThumbnail
          name
          file
          displayOrder
        }
      }
    }
    tags
  }
}
